export default __webpack_public_path__ + "static/media/sorenbn_photo.d3479ff5.jpg";